/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type EnumPatientContactType = "email" | "fax" | "inapp" | "sms" | "voice" | "whatsapp" | "%future added value";
export type IconPatientContactType_EmbedPatientContact = {
    readonly type: EnumPatientContactType | null;
    readonly " $refType": "IconPatientContactType_EmbedPatientContact";
};
export type IconPatientContactType_EmbedPatientContact$data = IconPatientContactType_EmbedPatientContact;
export type IconPatientContactType_EmbedPatientContact$key = {
    readonly " $data"?: IconPatientContactType_EmbedPatientContact$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"IconPatientContactType_EmbedPatientContact">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "IconPatientContactType_EmbedPatientContact",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    }
  ],
  "type": "PatientContact",
  "abstractKey": null
};
(node as any).hash = '257ff6b1bf0c8e11389cacccd6dbc742';
export default node;
